<template>
    <div>
    <div v-if="passed_filter">
        <div class="designeroption">
            <h3>Measurements</h3>
            <div class="stylesoption">
                <div v-for="measurement in measurements" :class="['form-group mb-3', target[measurement.slug] === undefined || target[measurement.slug] > limits[measurement.slug].max || target[measurement.slug] < limits[measurement.slug].min ? 'has-error' : 'has-success']">
                    <label :for="component_id + '_' + measurement.slug">{{ measurement.title.replace('Overall ', '') }} <template v-if="loading">(Checking Min/Max...)</template><template v-if="!loading">({{ limits[measurement.slug].min }}mm to {{ limits[measurement.slug].max }}mm)</template></label>
                    <input :dusk="measurement.slug" :id="component_id + '_' + measurement.slug" type="number" v-model="target[measurement.slug]" class="form-control"
                           :placeholder="measurement.title" min="{{ limits[measurement.slug].min }}" max="{{ limits[measurement.slug].max }}" pattern="[0-9]" @keydown="filterKey" @input="filterInput">
                <span v-if="show_message(measurement.slug, this.frameId)" class="txt-sm">
                    {{ show_message(measurement.slug, this.frameId) }}
                </span>
                </div>
                <div v-show="midrailHeight">
                    <label>Midrail height: {{ midrailHeight }}mm</label>
                </div>
            </div>
        </div>
    </div>
    </div>
</template>

<script type="text/ecmascript-6">
    import DesignerQuestionMeasurements from "./DesignerQuestionMeasurements.vue";

    export default {
        mixins: [
            DesignerQuestionMeasurements
        ],
        methods: {
            show_message(slug, frame) {
                if (slug === 'top_box_drop' || slug === 'right_width' || slug === 'left_width') {
                    if (!this.extendedTop(frame)) {
                        return 'This size includes any add on\'s you choose';
                    }
                    return 'This size includes 10mm coupler and any add on\'s you choose';
                }
                else if (slug === 'flag_height') {
                    return 'Inclusive of any sills or add on\'s';
                }
                if (this.singleFrame(frame)) {
                    if (slug === 'overall_width') {
                        return 'Inclusive of any add on\'s';
                    }
                    else if (slug === 'overall_height') {
                        return 'Inclusive of any sills or add on\'s';
                    }
                }
                return false;
            },
            extendedTop(frame) {
                frames = [3, 5, 8, 11];
                return frames.indexOf(frame) !== -1;
            },
            singleFrame(frame) {
                frames = [1, 13, 31, 36];
                return frames.indexOf(frame) !== -1;
            }
        },
        computed: {
            midrailHeight(){
                if (!this.limits ||
                    !this.limits['midrail_height'] ||
                    !this.limits['midrail_height'][this.localTarget['overall_height']]) {
                    return false;
                }
                return this.limits['midrail_height'][this.localTarget['overall_height']];
            },
        }
    }
</script>
